import arrowRight from "../../../public/graphics/nuoli_oikea.png";
const RightArrow = (props) => {
  const handleRightClick = () => {
    props.setClothes((prevObjects) => {
      const updatedObjects = [...prevObjects];
      const lastObject = updatedObjects.pop();
      updatedObjects.unshift(lastObject);
      return updatedObjects;
    });
  };
  return (
    <>
      <button onClick={handleRightClick} className="arrow-selection">
        <img src={arrowRight} className="centered-img" />
      </button>
    </>
  );
};

export default RightArrow;
